import React from 'react';
import i18n from '@i18n';
import { formatMoney } from '@/common/client';

function SystemNg({ systemStake, systemsCount, combination, ticketCount }) {
    return (
        <div className="row">
            <div>{i18n('tiket.detailTiketu.K_z_N_X_stavok', combination, systemsCount, ticketCount)}</div>
            <div>{formatMoney(systemStake, 'EUR')}</div>
        </div>
    );
}

export default SystemNg;
